var xmlns = "http://www.w3.org/2000/svg",
  select = function(s) {
    return document.querySelector(s);
  },
  selectAll = function(s) {
    return document.querySelectorAll(s);
  },
  container = select('.a-logo__link.animate-initiate')


//center the container cos it's pretty an' that
TweenMax.set(container, {
  // position: 'absolute',
  // top: '50%',
  // left: '50%',
  // xPercent: -50,
  // yPercent: -50
})

TweenMax.set('svg', {
  visibility: 'visible'
})

TweenMax.set('#example', {
  // transformOrigin:'50% 50%'
})


var tl = new TimelineMax({paused:false, repeat:0});

// Duck slides in
tl.from('#logoMark', 1.25, {
    y:30,
    x:-150,
    rotation:'-=20',
    ease:Circ.easeOut,
    opacity:0
})

// Duck wings flap
tl.from('#leftWing', 1.25, {
    morphSVG:{shape:'#leftWingAlt'},
    ease: CustomEase.create("custom", "M0,0 C0,0 0.049,0.675 0.085,1.115 0.122,1.498 0.156,1.34 0.16,1.322 0.189,1.193 0.219,0.575 0.246,0.442 0.278,0.282 0.303,1.27 0.307,1.276 0.335,1.319 0.413,0.559 0.444,0.6 0.494,0.682 0.484,1.008 0.53,0.984 0.58,0.951 0.667,1.002 0.725,1.004 0.829,1.008 1,1 1,1")
},'-=1')

tl.from('#rightWingDark', 1.25, {
    morphSVG:{shape:'#rightWingDarkAlt'},
    ease: CustomEase.create("custom", "M0,0 C0,0 0.049,0.675 0.085,1.115 0.122,1.498 0.156,1.34 0.16,1.322 0.189,1.193 0.219,0.575 0.246,0.442 0.278,0.282 0.303,1.27 0.307,1.276 0.335,1.319 0.413,0.559 0.444,0.6 0.494,0.682 0.484,1.008 0.53,0.984 0.58,0.951 0.667,1.002 0.725,1.004 0.829,1.008 1,1 1,1")
},'-=1.25')

tl.from('#rightWingLight', 1.25, {
    morphSVG:{shape:'#rightWingLightAlt'},
    ease: CustomEase.create("custom", "M0,0 C0,0 0.049,0.675 0.085,1.115 0.122,1.498 0.156,1.34 0.16,1.322 0.189,1.193 0.219,0.575 0.246,0.442 0.278,0.282 0.303,1.27 0.307,1.276 0.335,1.319 0.413,0.559 0.444,0.6 0.494,0.682 0.484,1.008 0.53,0.984 0.58,0.951 0.667,1.002 0.725,1.004 0.829,1.008 1,1 1,1")
},'-=1.25')


// Duck neck and feet
tl.from('#leftFoot', 0.7, {
    morphSVG:{shape:'#leftFootAlt'},
    ease:Power2.easeOut
},'-=0.7')

tl.from('#rightFoot', 0.7, {
    morphSVG:{shape:'#rightFootAlt'},
    ease:Power2.easeOut
},'-=0.7')

tl.from('#beak', 0.7, {
    morphSVG:{shape:'#beakAlt'},
    ease:Power2.easeOut
},'-=0.7')

tl.from('#face', 0.7, {
    morphSVG:{shape:'#faceAlt'},
    ease:Power2.easeOut
},'-=0.7')

tl.from('#body', 0.7, {
    morphSVG:{shape:'#bodyAlt'},
    ease:Power2.easeOut
},'-=0.7')

tl.from('#body2', 0.7, {
    morphSVG:{shape:'#body2Alt'},
    ease:Power2.easeOut
},'-=0.7')
